import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useDestinationList() {
    const tableColumns = [
        { key: 'title', label: 'Destination', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false },
    ]
    const searchQuery = ref('')
    const isDestinationFormSidebarActive = ref(false)
    const destinationData = ref(null)
    const refDestinationListTable = ref(null);
    const currentPage = ref(1)
    const perPage = ref(10)
    const statusFilter = ref(null)
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const totalDestinations = ref(0)
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const destinations = ref(null)
    const toast = useToast();
    const dataMeta = computed(() => {
        const localItemsCount = refDestinationListTable.value ? refDestinationListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalDestinations.value,
        }
    })

    const updateDestination = (data) => {
        destinationData.value = data
        isDestinationFormSidebarActive.value = true
    }

    const refetchData = () => {
        refDestinationListTable.value.refresh()
        fetchData()
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchData()
    })

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store.dispatch('app-review/getDestinations', {

            limit: perPage.value,
            offset:offset,
            keywords: searchQuery.value,
            sites_id: getLocalSite.id,

        }).then(response => {

            destinations.value = response.data.data
            totalDestinations.value = response.data.total

        }).catch(() => {

            toast({
              component: ToastificationContent,
              props: {
                title: "Error fetching Destination' list",
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })

        })
    }

    const resolveDestinationStatusVariant = status => {
        if (status) return 'success'
        if (!statuss) return 'secondary'
        return 'primary'
    }

    const resolveDestinationStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const deleteData = (id) => {
        store.dispatch('app-review/deleteDestination', id).then(response=>{
            fetchData()

            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Destination",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    text: error.response.data.message,
                },
            })
        })
    }

    return {
        tableColumns,
        updateDestination,
        searchQuery,
        isDestinationFormSidebarActive,
        destinationData,
        refetchData,
        fetchData,
        refDestinationListTable,
        sortBy,
        statusFilter,
        perPage,
        currentPage,
        isSortDirDesc,
        dataMeta,
        destinations,
        resolveDestinationStatusVariant,
        resolveDestinationStatusnameVariant,
        deleteData,
    }
}